// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"464":"7a4ca6f1","1677":"366ccb1a"}[chunkId] + ".chunk.css";
};